import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const showErrorToast = (message: string) => {
  toast.custom((t) => (
    <div
      onClick={() => toast.dismiss(t.id)}
      className={`${t.visible ? 'animate-enter' : 'animate-leave'
        } flex w-[300px] text-center cursor-default select-none items-center justify-center rounded bg-brand-red p-4 text-sm font-medium text-white shadow-lg`}>
      {message}
    </div>
  ));
};

export const showWarningMessage = (message: string, confirm: boolean = true) => {
  const MySwal = withReactContent(Swal);
  MySwal.fire({
    width: 600,
    html: (
      <div>
        <p className="text-base" dangerouslySetInnerHTML={{ __html: message }} />
        <div className="mt-4 flex w-full items-center justify-center">
          {confirm ? (
            <>
              <button
                className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
                onClick={() => MySwal.close()}>
                Confirm
              </button>
              <button
                className="rounded border border-brand-grey175 bg-white px-5 py-2 text-sm text-brand-black50"
                onClick={() => MySwal.close()}>
                Cancel
              </button>
            </>
          ) : (
            <button
              className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
              onClick={() => MySwal.close()}>
              OK
            </button>
          )}

        </div>
      </div>
    ),
    showConfirmButton: false
  });
}
